import { RDEqipCurrentPractices } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipCurrentPracticesTaskEditor } from './RDEqipCurrentPracticesTaskEditor'

export const RDEqipCurrentPracticesDetailFeature: ResourceDetailFeature<RDEqipCurrentPractices> = {
  traitId: 'eqipCurrentPractices',
  TaskEditor: RDEqipCurrentPracticesTaskEditor,
}
